<script setup lang="ts">
const props = defineProps(['modelValue', 'errors'])
const emit = defineEmits(['update:modelValue'])
const value = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  },
})
</script>

<template>
  <div class="flex flex-col gap-4 w-full">
    <div class="text-lg font-bold">
      {{ $t('register.general_info') }}
    </div>
    <div class="flex flex-col gap-4 md:flex-row w-full">
      <AccountInput
        v-model="value.first_name"
        :errors="errors.firstName.errorMessages"
        :label="$t('register.input.first_name')"
        @blur="errors.firstName.setBlurred"
      />
      <AccountInput
        v-model="value.last_name"
        :errors="errors.lastName.errorMessages"
        :label="$t('register.input.last_name')"
        @blur="errors.lastName.setBlurred"
      />
    </div>
    <div class="flex flex-col gap-4 md:flex-row w-full">
      <AccountInput
        v-model="value.email"
        :errors="errors.email.errorMessages"
        :label="$t('register.input.email')"
        @blur="errors.email.setBlurred"
      />

      <AccountInput
        v-model="value.phone"
        :errors="errors.phone.errorMessages"
        :label="$t('register.input.phonenumber')"
        @blur="errors.phone.setBlurred"
      />
    </div>
    <div class="flex flex-col gap-4 md:flex-row w-full">
      <AccountInput
        v-model="value.password"
        :is-password="true"
        :errors="errors.password.errorMessages"
        :label="$t('register.input.password')"
        @blur="errors.password.setBlurred"
      />

      <AccountInput
        v-model="value.password_confirmation"
        :is-password="true"
        :errors="errors.passwordConfirmation.errorMessages"
        :label="$t('register.input.repeat_password')"
        @blur="errors.passwordConfirmation.setBlurred"
      />
    </div>

    <div
      v-if="value.type === 'b2b'"
      class="flex flex-col gap-4 md:flex-row"
    >
      <AccountInput
        v-model="value.company_name"
        :errors="errors.companyName.errorMessages"
        :label="$t('register.input.company_name')"
        @blur="errors.companyName.setBlurred"
      />
      <AccountInput
        v-model="value.vat"
        :errors="errors.vat.errorMessages"
        :label="$t('register.input.vat')"
        @blur="errors.vat.setBlurred"
      />
    </div>
  </div>
</template>

<style scoped>
input::placeholder {
  opacity: 30%;
  font-weight: bold;
}
</style>
